import styled, { AnyStyledComponent, css } from 'styled-components'
import { desktopBreakpoint } from 'react-components'

import { WidgetCard } from '../widget-card'
import {
    CalendarIcon,
    GuestsIcon,
    LocationPinIcon,
    MailIcon,
    WhatsappIcon,
    FacebookIcon,
    MessangerIcon,
    LinkIcon,
    CallIcon,
    ThunderIcon,
    ChevronDownIcon,
    BuildingIcon,
    EditIcon,
} from '../../../common/icons'
import { InputError } from '../../../common/input-styles'

interface WidgetContainerProps {
    isRounded?: string
}

export const WidgetContainer = styled.div`
    position: relative;
    width: 100%;
`

interface WidgetInputContainerProps {
    hasError?: boolean
}

export const WidgetInputContainer = styled.div<WidgetInputContainerProps>(
    ({ theme, hasError }) => css`
        position: relative;
        display: flex;
        align-items: center;
        background-color: white;
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        height: 3rem;

        ${WidgetContainer}:first-child & {
            border-radius: ${theme.typography.border.radius.small} 0 0 ${theme.typography.border.radius.small};
        }

        ${WidgetContainer}:last-child & {
            border-radius: 0 ${theme.typography.border.radius.small} ${theme.typography.border.radius.small} 0;
        }

        ${!!hasError &&
        css`
            border-color: ${theme.colors.tfwErrorRed};

            & *:not(${InputError}) {
                color: ${theme.colors.tfwErrorRed};
                stroke: ${theme.colors.tfwErrorRed};
            }
        `};
    `,
)

export const NonSelectableWidgetInputContainer = styled(WidgetInputContainer)<WidgetContainerProps>(
    ({ isRounded }) => css`
        user-select: none;
        width: 100%;

        ${isRounded &&
        css`
            border-radius: ${isRounded} !important;
        `};
    `,
)

export const WidgetInput = styled.input(
    ({ theme }) => css`
        background-color: transparent;
        padding: ${theme.spacing.xSmall} ${theme.spacing.xSmall} ${theme.spacing.xSmall} 2.25rem;
        width: 100%;
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.xLarge};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.xxLarge};
        }
    `,
)

export const WidgetText = styled.div(
    ({ theme }) => css`
        background-color: transparent;
        padding: ${theme.spacing.xSmall} ${theme.spacing.xSmall} ${theme.spacing.xSmall} 2.25rem;
        width: 100%;
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.xLarge};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.xxLarge};
        }
    `,
)

export const InputIcon = styled.svg(
    ({ theme }) => css`
        position: absolute;
        left: ${theme.spacing.small};

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            left: ${theme.spacing.medium};
        }
    `,
)

export const InputIconRight = styled.svg(
    ({ theme }) => css`
        position: absolute;
        right: ${theme.spacing.small};
        height: 1.25rem;
        width: auto;
        flex-shrink: 0;
    `,
)

export const LocationPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: LocationPinIcon })``
export const DatePickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: CalendarIcon })``
export const GuestPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: GuestsIcon })``
export const EntityPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: BuildingIcon })``
export const EntityEditIcon = styled(InputIconRight as AnyStyledComponent).attrs({ as: EditIcon })`
    cursor: pointer;
`
export const ChevronDownPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: ChevronDownIcon })``
export const MailPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: MailIcon })``
export const ThunderPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: ThunderIcon })``

export const WhatsAppIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: WhatsappIcon })``
export const FaceBookIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: FacebookIcon })``
export const MessengerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: MessangerIcon })``
export const CopyLinkIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: LinkIcon })``
export const CallPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: CallIcon })``

export const SearchbarWidgetCard = styled(WidgetCard)(
    ({ theme }) => css`
        top: 100%;
        margin-top: ${theme.spacing.xxSmall};
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        box-shadow: 0 8px 10px #0000000f, 0 3px 14px #0000000a, 0 5px 5px #00000014;
        z-index: 10;
    `,
)
